export const APP_TOKEN = 'APP_TOKEN';

export const REFRESH_TOKEN = 'REFRESH_TOKEN';

export const USER_ID = 'USER_ID';

export const USER_ROLE = 'USER_ROLE';

export const SUBSCRIPTION_STATUS = 'SUBSCRIPTION_STATUS';

export const TERMS_CONDITIONS = 'TERMS_CONDITIONS';

export const TRADE_CREATION = 'TRADE_CREATION';

export const RESTRICT_PROJECT_CREATION = 'RESTRICT_PROJECT_CREATION';
